import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { CalendarColumnBodyVariant } from '../../types';
import { ColumnEvents } from '../column-events';

interface Props {
  columnIds: string[];
  startColumn: number;
  columnBodyVariant: CalendarColumnBodyVariant;
}

export const GroupBody = ({ columnIds, startColumn, columnBodyVariant }: Props) => {
  return columnIds.map((columnId, index) => (
    <div
      data-column-id={columnId}
      key={columnId}
      css={[columnStyle, columnBodyVariant === 'stacked' && stackedColumnStyle]}
      style={{
        gridColumn: `${startColumn + index} / span 1`,
        borderInlineStartWidth: index === 0 ? 1 : 0,
      }}
    >
      <ColumnEvents columnId={columnId} />
    </div>
  ));
};

const columnStyle = css({
  gridRow: '2 / -1', // Spans all rows except the header
  display: 'grid',
  gridTemplateRows: 'repeat(var(--total-mins), var(--row-height))', // NOTE: contentVisibility not works with subgrid
  // Native browser virtualization hint
  contentVisibility: 'auto',
  containIntrinsicSize: `var(--column-min-width) calc(var(--row-height) * var(--total-mins))`,
  // Optimization: Tell the browser this won't change often
  // contain: "layout style paint",

  borderInlineWidth: '0 1px',
  borderInlineColor: theme.colors.neutral20,
  borderInlineStyle: 'solid',
  scrollSnapAlign: 'start',
});

const stackedColumnStyle = css({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(0.5),
  paddingTop: theme.spacing(3),
  borderInline: 'none',
  padding: theme.spacing(3, 1),
});
